/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from 'react'

import './Mobile.scss'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import Logo from '../../assets/svg/logo.svg'

import { Link } from 'react-router-dom'

import { post } from '../../services/https'
import { useNavigate } from 'react-router-dom'

import loadingPic from '../../assets/svg/Loading.svg'

export default function index() {
  const [phoneNumber, setPhoneNumber] = useState()
  const [alertPhoneNumber, setAlertPhoneNumber] = useState(false)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const signInHandler = (e) => {
    e.preventDefault()
    if (phoneNumber !== undefined && phoneNumber.length === 11) {
      setLoading(true)
      setAlertPhoneNumber(false)
      post('/api/front/sendsms', {
          phoneNumber: phoneNumber
        }, {
          'Content-Type': 'application/json'
        }).then(response => {
          if (response.data.messageFa === "پیام با موفقیت ارسال شد") {
            navigate('/verfication')
            localStorage.setItem('phoneNumber', phoneNumber)
          }
        }).catch(error => {
          if (error.response.data.messageFa === 'شما قبلاً ثبت نام کرده‌اید') {
            notify('error', 'شما قبلاً ثبت نام کرده‌اید')
            setTimeout(() => {
              navigate('/login')
            }, 4000)
          } else {
            notify('error', 'دریافت اطلاعات با خطا مواجه شد')
          }
        })
    } else {
      setAlertPhoneNumber(true)
    }
  }

  return (
    <div id='login'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll'>
        <img src={Logo} alt='Logo' />
        <span className='title'>کانولی</span>
        <span className='subtitle'>خوش آمدید</span>
        <form action=''>
          <div className='input'>
            <label htmlFor=''>شماره موبایل :</label>
            <input onChange={(e) => setPhoneNumber(e.target.value)} type='number' name='' id='' placeholder='شماره موبایل' />
            <small style={alertPhoneNumber ? {} : { display: 'none' }}>شماره موبایل صحیح نیست</small>
          </div>
          <div className='button'>
            <span>
            </span>
            <span>
              <button onClick={signInHandler} style={{ whiteSpace: 'nowrap' }}><span style={loading ? {display: 'none'} : {}}>ثبت نام </span><img style={loading ? {} : {display: 'none'}} className='loadingPic' src={loadingPic} alt='loadingPic' /></button>
            </span>
          </div>
          <div className='signUp'>
            <span>ثبت نام کرده اید؟</span>
            <Link to='/login' className='signInButton'>ورود</Link>
          </div>
        </form>
      </div>
      <Footer page={''} />
    </div>
  )
}
